import { useEffect } from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { toast } from 'sonner';

const FLAG = 'growthriq_dashboard_first_visit_v1';

/**
 * Fires a one-time confetti burst + welcoming toast the first time a user
 * lands on the dashboard. Subsequent visits are silent.
 */
export default function useFirstDashboardVisit({ enabled = true } = {}) {
  const { t, language } = useLanguage();

  useEffect(() => {
    if (!enabled) return;
    if (typeof window === 'undefined') return;
    if (localStorage.getItem(FLAG) === '1') return;

    let cancelled = false;
    const run = async () => {
      try {
        const mod = await import('canvas-confetti');
        if (cancelled) return;
        const confetti = mod.default || mod;
        // Two staggered bursts from bottom-left & bottom-right corners
        const colors = ['#3CD9B8', '#0F1B36', '#FFD166', '#06D6A0'];
        confetti({
          particleCount: 70,
          spread: 65,
          startVelocity: 45,
          origin: { x: 0.15, y: 0.95 },
          angle: 60,
          colors,
        });
        setTimeout(() => {
          confetti({
            particleCount: 70,
            spread: 65,
            startVelocity: 45,
            origin: { x: 0.85, y: 0.95 },
            angle: 120,
            colors,
          });
        }, 200);
      } catch (_e) {
        // confetti is non-critical
      }

      // Friendly nudge
      toast.success(
        language === 'tr'
          ? 'İlk skorunuza 30 saniye uzaktasınız 🚀'
          : 'You are 30 seconds away from your first score 🚀',
        { duration: 5500 },
      );
      try {
        localStorage.setItem(FLAG, '1');
      } catch (_) {
        /* noop */
      }
    };

    // Small delay so it lands after layout settles + after the welcome modal closes
    const timer = setTimeout(run, 900);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);
}
